import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import api from "../../../services/api";
import Loader from "../../../core/common/loader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { showBasicAlert } from "../../../core/common/useAlert";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import { Modal, Spin } from "antd";

import EmployeeAssetsInformation from "./employeeAssetsInformation";
import { humanReadableDate } from "../../../helper/dateTimeHelper";
const EmployeeDetails = () => {
  const user = useSelector((state: any) => state.user.user);
  const hasEditPermissionForEmployees = user?.userDetails?.permissions?.some(
    (permissionObj: any) =>
      permissionObj.name === "Employees" &&
      permissionObj.permissions.includes("Edit")
  );

  const location = useLocation();
  const comingFromtype = location.state?.type || "emp_list";

  const [showFullImage, setShowFullImage] = useState(false);
  const { id } = useParams();
  const [data, setData] = useState<any | null>(null);
  const signature = localStorage.getItem("signature");
  const [isLoading, setIsLoading] = useState(false); // state to track loading
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [employeeAddress, setEmployeeAddress] = useState<any | null>(null);
  const [employeePersonal, setEmployeePersonal] = useState<any | null>(null);
  const [employeeBankDetails, setEmployeeBankDetails] = useState<any | null>(
    null
  );
  const [companyId, setCompanyId] = useState<number | null>(null);
  const [companyType, setCompanyType] = useState<string | null>(null);
  const [ticketCategories, setTicketCategories] = useState<any[]>([]);
  const [requestBody, setRequestBody] = useState<any>({
    key: "", // Category ID
    Title: "",
    Description: "",
  });
  const [countries, setCountries] = useState<any[]>([]);
  const [c_countries, setc_Countries] = useState<any[]>([]);

  const [statesOrignal, setStatesOrignal] = useState<any[]>([]);
  const [states, setStates] = useState<any[]>([]);
  const [c_states, setc_States] = useState<any[]>([]);

  const [citiesOrignal, setCitiesOrignal] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);
  const [c_cities, setc_Cities] = useState<any[]>([]);
  const [assignedAsset, setAssinedAsset] = useState<any[]>([]);
  const [assignedAssetInformation, setAssinedAssetInformation] = useState<any>(
    {}
  );
  const [sameAsPermanent, setSameAsPermanent] = useState(false);

  useEffect(() => {
    updateUI();
  }, [id]);

  useEffect(() => {
    document.addEventListener("DOMContentLoaded", function () {
      const tabBtn = document.getElementById("address-tab2");
      const tabPane = document.getElementById("address2");

      tabBtn?.addEventListener("click", function (e) {
        if (
          tabBtn.classList.contains("active") &&
          tabPane?.classList.contains("show")
        ) {
          tabBtn.classList.remove("active");
          tabBtn.setAttribute("aria-selected", "false");
          tabPane.classList.remove("show", "active");
        }
      });
    });
  }, []);

  const getAssetInformations = async (id: any) => {
    try {
      // return
      const response = await api.post("assetService/getAssignedAssetDetails", {
        signature,
        id,
      });
      setAssinedAssetInformation(response?.data?.data?.data);
    } catch (error) {
      console.error("Error in getAssetInformations", error);
      // showBasicAlert("Error", "Failed to fetch asset information.");
    }
  };

  const handleRaiseIssueClick = async (id: any) => {
    try {
      const response = await api.post("assetService/getAssignedAssetDetails", {
        signature,
        id,
      });
      // Extract company details and store them in state
      const company_id = response?.data?.data?.data?.company_id || null;
      const company_type = response?.data?.data?.data?.company_type || null;

      setCompanyId(parseInt(company_id));
      setCompanyType(company_type);

      const filteredCategories = ticketCategories.filter(
        (category: any) =>
          parseInt(category.CompanyId) === parseInt(company_id) &&
          category.CompanyType === company_type
      );

      setTicketCategories(filteredCategories);
      setAssinedAssetInformation(response?.data?.data?.data || {});
    } catch (error) {
      console.error("Error fetching asset details:", error);
      showBasicAlert("An error occurred while fetching asset details.");
    }
  };

  // Function to submit the issue
  const submitRaiseIssue = async () => {
    const body = {
      signature: signature,
      status: 1,
      company_id: companyId,
      company_type: companyType,
      product_id: assignedAssetInformation.product_id || null,
      category_id: parseInt(requestBody.key),
      title: requestBody.Title || "",
      description: requestBody.Description || "",
      priority:
        requestBody.Priority !== "" ? parseInt(requestBody.Priority) : 0,
    };
    try {
      setIsLoading(true);
      const response = await api.post(
        "raiseTicketsService/addRaiseTicket",
        body
      );
      showBasicAlert(response.data.message[0].msg);
    } catch (error: any) {
      showBasicAlert(error.data.message[0].msg);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e: any) => {
    setRequestBody({ ...requestBody, [e.target.name]: e.target.value });
  };

  const updateUI = async () => {
    setIsRefreshing(true);
    try {
      const [
        employeeDetails,
        countryResponse,
        stateResponse,
        cityResponse,
        employeeAddress,
        getEmployeeAssignedAssets,
      ] = await Promise.all([
        api.post("userService/getEmployeeById", { signature, id }),
        api.post("userService/getCountry", { signature }),
        api.post("userService/getState", { signature }),
        api.post("userService/getCity", { signature }),
        api.post("userService/getUserDetail", { signature, id }),
        api.post("assetService/getEmployeeAssignedAssets", { signature, id }),
      ]);

      setCountries(countryResponse?.data?.data || []);
      setc_Countries(countryResponse?.data?.data || []);
      const statesOriginal = stateResponse?.data?.data || [];
      setStatesOrignal(statesOriginal);
      setAssinedAsset(getEmployeeAssignedAssets?.data?.data?.data);

      var allTicketCategories = await api.post(
        "raiseTicketsService/getAllTicketCategories",
        {
          signature,
          company_id: employeeDetails?.data?.data?.data.company_id,
          company_type: employeeDetails?.data?.data?.data.company_type,
        }
      );

      setTicketCategories(allTicketCategories?.data?.data?.data);
      const filteredStates = statesOriginal.filter(
        (state: any) =>
          state.country_id ===
          employeeAddress?.data?.data?.data?.userAddress?.country
      );
      setStates(filteredStates);

      // Safely set cities and filter them
      const citiesOriginal = cityResponse?.data?.data || [];
      setCitiesOrignal(citiesOriginal);

      const filteredCities = citiesOriginal.filter(
        (city: any) =>
          city.state_id ===
          employeeAddress?.data?.data?.data?.userAddress?.state
      );
      setCities(filteredCities);

      // Safely set employee details and address
      setData(employeeDetails?.data?.data?.data || {});

      setFormDataEmployeeDetails({
        employee_id:
          employeeDetails?.data?.data?.data.Employee_ID == "N/A"
            ? ""
            : employeeDetails?.data?.data?.data.Employee_ID,
      });

      setFormDataEmployeeBasicDetails({
        phone_code: employeeDetails?.data?.data?.data.phone_code,
        mobile_no: employeeDetails?.data?.data?.data.mobile_no,
        official_phone_code:
          employeeDetails?.data?.data?.data.official_phone_code,
        official_mobile_no:
          employeeDetails?.data?.data?.data.official_mobile_no,
        email: employeeDetails?.data?.data?.data.email,
        gender: employeeDetails?.data?.data?.data.gender,
        dob: employeeDetails?.data?.data?.data.dob,
      });

      const userAddress = employeeAddress?.data?.data?.data?.userAddress || {};
      setEmployeeAddress(userAddress);

      setFormDataAddress({
        address1: userAddress?.address1 || "",
        address2: userAddress?.address2 || "",
        country: userAddress?.country || "",
        state: userAddress?.state || "",
        city: userAddress?.city || "",
        pincode: userAddress?.pincode || "",
        c_address1: userAddress?.c_address1 || "",
        c_address2: userAddress?.c_address2 || "",
        c_country: userAddress?.c_country || "",
        c_state: userAddress?.c_state || "",
        c_city: userAddress?.c_city || "",
        c_pincode: userAddress?.c_pincode || "",
      });

      // Safely set employee personal details
      const userPersonal =
        employeeAddress?.data?.data?.data?.userPersonal || {};
      setEmployeePersonal(userPersonal);

      setFormDataPersonal({
        nationality: userPersonal?.nationality || "",
        religion: userPersonal?.religion || "",
        marital: userPersonal?.marital_status || "",
        blood_group: userPersonal?.blood_group || "",
        spouse_name: userPersonal?.spouse_name || "",
        anniversary_date: userPersonal?.anniversary_date || "",
        spouse_contact: userPersonal?.spouse_contact || "",
      });

      // Safely set emergency details
      setFormDataEmergencyDetail({
        emergency_name1: userPersonal?.emergency_name1 || "",
        emergency_name2: userPersonal?.emergency_name2 || "",
        emergency_relation1: userPersonal?.emergency_relation1 || "",
        emergency_relation2: userPersonal?.emergency_relation2 || "",
        emergency_no1: userPersonal?.emergency_no1 || "",
        emergency_no2: userPersonal?.emergency_no2 || "",
      });

      // Safely set bank details
      setEmployeeBankDetails(employeeAddress?.data?.data?.data?.userBank || {});

      setformDataBankDetails({
        bank_name: employeeAddress?.data?.data?.data?.userBank?.bank_name || "",
        account_no:
          employeeAddress?.data?.data?.data?.userBank?.account_no || "",
        ifsc_code: employeeAddress?.data?.data?.data?.userBank?.ifsc_code || "",
        branch_address:
          employeeAddress?.data?.data?.data?.userBank?.branch_address || "",
      });
    } catch (err: any) {
      showBasicAlert(err.data.message[0].msg);
      console.error("Error fetching dashboard data:", err);
    } finally {
      setIsRefreshing(false);
    }
  };

  const martialstatus = [
    { value: "Yes", label: "Married" },
    { value: "No", label: "Un-Married" },
  ];

  const bloodGroups = [
    { value: "A+", label: "A+" },
    { value: "A-", label: "A-" },
    { value: "B+", label: "B+" },
    { value: "B-", label: "B-" },
    { value: "O+", label: "O+" },
    { value: "O-", label: "O-" },
    { value: "AB+", label: "AB+" },
    { value: "AB-", label: "AB-" },
  ];

  const handleCopyEmail = () => {
    if (data?.Email) {
      navigator.clipboard
        .writeText(data.Email)
        .then(() => {
          toast.success("Email copied to clipboard!", {
            position: "top-right",
          });
        })
        .catch((err) => {
          console.error("Failed to copy email: ", err);
        });
    }
  };

  const initialFormDataEmployeeDetails = {
    employee_id: "",
  };
  const [FormDataEmployeeDetails, setFormDataEmployeeDetails] = useState(
    initialFormDataEmployeeDetails
  );

  const handleInputChangEmployeeDetails = (e: any) => {
    const { name, value } = e.target;
    setFormDataEmployeeDetails((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmitEmployeeInfo = async (e: any) => {
    e.preventDefault();
    const signature = localStorage.getItem("signature");

    const dataToSend = {
      signature: signature,
      id: id,
      emp_id: FormDataEmployeeDetails.employee_id,
    };

    try {
      setIsLoading(true);
      const response = await api.post(
        "userService/updateEmployeeDetails",
        dataToSend
      );
      await updateUI();
      setIsLoading(false); // hide loader after response
      showBasicAlert(response.data.message[0].msg);
    } catch (error: any) {
      setIsLoading(false); // hide loader after response
      showBasicAlert(error.data.message[0].msg);
    }
  };

  const initialFormDataEmployeeBasicDetails = {
    phone_code: "",
    mobile_no: "",
    official_mobile_no: "",
    official_phone_code: "",
    email: "",
    gender: "",
    dob: "",
  };
  const [FormDataEmployeeBasicDetails, setFormDataEmployeeBasicDetails] =
    useState(initialFormDataEmployeeBasicDetails);

  const handleInputChangEmployeeBasicDetails = (e: any) => {
    const { name, value } = e.target;
    setFormDataEmployeeBasicDetails((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmitEmployeeBasicDetails = async (e: any) => {
    e.preventDefault();

    // Form data to be sent to API
    const signature = localStorage.getItem("signature");

    const dataToSend = {
      signature: signature,
      id: id,
      phone_code: FormDataEmployeeBasicDetails.phone_code,
      mobile_no: FormDataEmployeeBasicDetails.mobile_no,
      official_mobile_no: FormDataEmployeeBasicDetails.official_mobile_no,
      official_phone_code: FormDataEmployeeBasicDetails.official_phone_code,
      email: FormDataEmployeeBasicDetails.email,
      gender: FormDataEmployeeBasicDetails.gender,
      dob: FormDataEmployeeBasicDetails.dob,
    };

    try {
      setIsLoading(true);
      const response = await api.post(
        "userService/updateEmployeeBasic",
        dataToSend
      );
      await updateUI();
      setIsLoading(false); // hide loader after response
      showBasicAlert(response.data.message[0].msg);
    } catch (error: any) {
      setIsLoading(false); // hide loader after response
      showBasicAlert(error.data.message[0].msg);
    }
  };

  const initialFormDataAddress = {
    address1: "",
    address2: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    c_address1: "",
    c_address2: "",
    c_country: "",
    c_state: "",
    c_city: "",
    c_pincode: "",
  };
  const [formDataAddress, setFormDataAddress] = useState(
    initialFormDataAddress
  );

  const handleInputChangeAddress = (e: any) => {
    const { name, value } = e.target;
    setFormDataAddress((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSameAddressToggle = (checked: any) => {
    setSameAsPermanent(checked);
    if (checked) {
      setFormDataAddress((prev) => ({
        ...prev,
        c_address1: prev.address1,
        c_address2: prev.address2,
        c_country: prev.country,
        c_state: prev.state,
        c_city: prev.city,
        c_pincode: prev.pincode,
      }));
    }
  };

  const handleCountryChange = (e: any) => {
    const countryId = e.target.value;
    setFormDataAddress((prevData) => ({
      ...prevData,
      country: countryId,
      state: "", // Reset state
      city: "", // Reset city
    }));
    // Filter states based on country selection
    const filteredStates = statesOrignal.filter(
      (state) => state.country_id == countryId
    );
    setStates(filteredStates);
  };

  const handleStateChange = (e: any) => {
    const stateId = e.target.value;
    // Filter cities based on state selection
    setFormDataAddress((prevData) => ({
      ...prevData,
      state: stateId,
      city: "", // Reset city when state changes
    }));

    const filteredCities = citiesOrignal.filter(
      (city) => city.state_id == stateId
    );
    setCities(filteredCities);
  };

  const handleCityChange = (e: any) => {
    const cityId = e.target.value;
    // Filter cities based on state selection
    setFormDataAddress((prevData) => ({
      ...prevData,
      city: cityId, // Reset city when state changes
    }));
  };

  const handleCurrentCountryChange = (e: any) => {
    const countryId = e.target.value;
    setFormDataAddress((prevData) => ({
      ...prevData,
      c_country: countryId,
      c_state: "", // Reset state
      c_city: "", // Reset city
    }));
    // Filter states based on country selection
    const filteredStates = statesOrignal.filter(
      (state) => state.country_id == countryId
    );
    setc_States(filteredStates);
  };

  const handleCurrentStateChange = (e: any) => {
    const stateId = e.target.value;
    // Filter cities based on state selection
    setFormDataAddress((prevData) => ({
      ...prevData,
      c_state: stateId,
      c_city: "", // Reset city when state changes
    }));

    const filteredCities = citiesOrignal.filter(
      (city) => city.state_id == stateId
    );
    setc_Cities(filteredCities);
  };

  const handleCurrentCityChange = (e: any) => {
    const cityId = e.target.value;
    // Filter cities based on state selection
    setFormDataAddress((prevData) => ({
      ...prevData,
      c_city: cityId, // Reset city when state changes
    }));
  };

  const handleSubmitAddress = async (e: any) => {
    e.preventDefault();

    // Form data to be sent to API
    const signature = localStorage.getItem("signature");

    const dataToSend = {
      signature: signature,
      id: id,
      address1: formDataAddress.address1,
      address2: formDataAddress.address2,
      country: formDataAddress.country,
      state: formDataAddress.state,
      city: formDataAddress.city,
      pincode: formDataAddress.pincode,
      c_address1: formDataAddress.c_address1,
      c_address2: formDataAddress.c_address2,
      c_country: formDataAddress.c_country,
      c_state: formDataAddress.c_state,
      c_city: formDataAddress.c_city,
      c_pincode: formDataAddress.c_pincode,
    };

    try {
      setIsLoading(true);
      const response = await api.post(
        "userService/updateEmployeeAddress",
        dataToSend
      );
      await updateUI();
      setIsLoading(false); // hide loader after response
      showBasicAlert(response.data.message[0].msg);
    } catch (error: any) {
      setIsLoading(false); // hide loader after response
      showBasicAlert(error.data.message[0].msg);
    }
  };

  const initialFormDataPersonal = {
    nationality: "",
    religion: "",
    marital: "",
    blood_group: "",
    spouse_name: "",
    anniversary_date: "",
    spouse_contact: "",
  };
  const [formDataPersonal, setFormDataPersonal] = useState(
    initialFormDataPersonal
  );

  const handleCountryChangePersonal = (e: any) => {
    const countryId = e.target.value;
    setFormDataPersonal((prevData) => ({
      ...prevData,
      nationality: countryId,
    }));
  };

  const handleMaritialChangePersonal = (e: any) => {
    const maritialStatus = e.target.value;
    setFormDataPersonal((prevData) => ({
      ...prevData,
      marital: maritialStatus,
    }));
  };

  const handleBloodGroupChangePersonal = (e: any) => {
    const bloodGroup = e.target.value;
    setFormDataPersonal((prevData) => ({
      ...prevData,

      blood_group: bloodGroup,
    }));
  };

  const handleInputChangePersonal = (e: any) => {
    const { name, value } = e.target;
    setFormDataPersonal((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmitPersonal = async (e: any) => {
    e.preventDefault();

    // Form data to be sent to API
    const signature = localStorage.getItem("signature");

    const dataToSend = {
      signature: signature,
      id: id,
      nationality: formDataPersonal.nationality,
      religion: formDataPersonal.religion,
      marital_status: formDataPersonal.marital,
      blood_group: formDataPersonal.blood_group,
      spouse_name: formDataPersonal.spouse_name,
      anniversary_date: formDataPersonal.anniversary_date,
      spouse_contact: formDataPersonal.spouse_contact,
    };

    try {
      setIsLoading(true);
      const response = await api.post(
        "userService/updateEmployeePersonal",
        dataToSend
      );
      await updateUI();
      setIsLoading(false); // hide loader after response
      showBasicAlert(response.data.message[0].msg);
    } catch (error: any) {
      setIsLoading(false); // hide loader after response
      showBasicAlert(error.data.message[0].msg);
    }
  };

  const relationship = [
    { value: "Father", label: "Father" },
    { value: "Mother", label: "Mother" },
    { value: "Brother", label: "Brother" },
    { value: "Sister", label: "Sister" },
    { value: "Wife", label: "Wife" },
    { value: "Husband", label: "Husband" },
  ];

  const initialFormDataEmergencyDetail = {
    emergency_name1: "",
    emergency_relation1: "",
    emergency_no1: "",
    emergency_name2: "",
    emergency_relation2: "",
    emergency_no2: "",
  };
  const [formDataEmergencyDetail, setFormDataEmergencyDetail] = useState(
    initialFormDataEmergencyDetail
  );

  const handleInputChangeEmergencyDetails1 = (e: any) => {
    const { name, value } = e.target;
    setFormDataEmergencyDetail((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleRelationShip1Change = (e: any) => {
    const emergency_relation1 = e.target.value;
    setFormDataEmergencyDetail((prevData) => ({
      ...prevData,
      emergency_relation1: emergency_relation1,
    }));
  };

  const handleInputChangeEmergencyDetails2 = (e: any) => {
    const { name, value } = e.target;
    setFormDataEmergencyDetail((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleRelationShip2Change = (e: any) => {
    const emergency_relation2 = e.target.value;
    setFormDataEmergencyDetail((prevData) => ({
      ...prevData,
      emergency_relation2: emergency_relation2,
    }));
  };

  const handleSubmitEmergency = async (e: any) => {
    e.preventDefault();

    // Form data to be sent to API
    const signature = localStorage.getItem("signature");

    const dataToSend = {
      signature: signature,
      id: id,
      emergency_name1: formDataEmergencyDetail.emergency_name1,
      emergency_name2: formDataEmergencyDetail.emergency_name2,
      emergency_relation1: formDataEmergencyDetail.emergency_relation1,
      emergency_relation2: formDataEmergencyDetail.emergency_relation2,
      emergency_no1: formDataEmergencyDetail.emergency_no1,
      emergency_no2: formDataEmergencyDetail.emergency_no2,
    };

    try {
      setIsLoading(true);
      const response = await api.post(
        "userService/updateEmployeeEmergency",
        dataToSend
      );
      await updateUI();
      setIsLoading(false); // hide loader after response
      showBasicAlert(response.data.message[0].msg);
    } catch (error: any) {
      setIsLoading(false); // hide loader after response
      showBasicAlert(error.data.message[0].msg);
    }
  };

  const initialFormDataBankInfo = {
    bank_name: "",
    account_no: "",
    ifsc_code: "",
    branch_address: "",
  };
  const [formDataBankDetails, setformDataBankDetails] = useState(
    initialFormDataBankInfo
  );

  const handleInputChangeBankDetails = (e: any) => {
    const { name, value } = e.target;
    setformDataBankDetails((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmitBankDetails = async (e: any) => {
    e.preventDefault();

    // Form data to be sent to API
    const signature = localStorage.getItem("signature");

    const dataToSend = {
      signature: signature,
      id: id,
      bank_name: formDataBankDetails.bank_name,
      account_no: formDataBankDetails.account_no,
      ifsc_code: formDataBankDetails.ifsc_code,
      branch_address: formDataBankDetails.branch_address,
    };

    try {
      setIsLoading(true);
      const response = await api.post(
        "userService/updateEmployeeBanbkDetails",
        dataToSend
      );
      await updateUI();
      setIsLoading(false); // hide loader after response
      showBasicAlert(response.data.message[0].msg);
    } catch (error: any) {
      setIsLoading(false); // hide loader after response
      showBasicAlert(error.data.message[0].msg);
    }
  };

  const initialFormDataFamilyInfo = {
    name: "",
    relationship: "",
    phone_no: "",
  };
  const [formDataFamilyInfo, setformDataFamilyInfo] = useState(
    initialFormDataFamilyInfo
  );

  const handleInputChangeFamilyInfo = (e: any) => {
    const { name, value } = e.target;
    setformDataFamilyInfo((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleRelationShipFamily = (e: any) => {
    const relationship = e.target.value;
    setformDataFamilyInfo((prevData) => ({
      ...prevData,
      relationship: relationship,
    }));
  };

  const handleSubmitFamilyInfo = async (e: any) => {
    e.preventDefault();

    // Form data to be sent to API
    const signature = localStorage.getItem("signature");

    const dataToSend = {
      signature: signature,
      id: id,
      family_name: formDataFamilyInfo.name,
      contact_no: formDataFamilyInfo.phone_no,
      family_relation: formDataFamilyInfo.relationship,
    };

    try {
      setIsLoading(true);
      const response = await api.post(
        "userService/updateEmployeeFamilyDetail",
        dataToSend
      );
      await updateUI();
      setIsLoading(false); // hide loader after response
      showBasicAlert(response.data.message[0].msg);
    } catch (error: any) {
      setIsLoading(false); // hide loader after response
      showBasicAlert(error.data.message[0].msg);
    }
  };

  const emojiFromUPlus = (val?: string) => {
    if (!val) return "";
    // pick all U+XXXXXX tokens, fallback to split by non-hex
    const tokens =
      val.match(/U\+[0-9A-F]{4,6}/gi)?.map((t) => t.slice(2)) ||
      val
        .replace(/U\+/gi, "")
        .split(/[^0-9A-F]+/i)
        .filter(Boolean);

    return String.fromCodePoint(...tokens.map((h) => parseInt(h, 16)));
  };

  if (data == null) {
    return <Loader />;
  } else {
    return (
      <>
        {isLoading && <Loader />}
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h6 className="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
                  {hasEditPermissionForEmployees === true ||
                    user?.userDetails.role_char?.toLowerCase() === "admin" ? (
                    <Link
                      to={
                        comingFromtype === "emp_list"
                          ? all_routes.employeeList
                          : all_routes.employeeGrid
                      }
                    >
                      <i className="ti ti-arrow-left me-2" />
                      Employee Details
                    </Link>
                  ) : (
                    <span style={{ color: "#aaa", cursor: "not-allowed" }}>
                      <i className="ti ti-arrow-left me-2" />
                      Employee Details
                    </span>
                  )}
                </h6>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                <div className="head-icons ms-2">
                  <CollapseHeader />
                </div>
              </div>
            </div>
            {/* /Breadcrumb */}
            {isRefreshing && (
              <div className="d-flex flex-column align-items-center justify-content-center w-100 text-center py-5">
                <Spin size="large" />
                <p className="mt-3 mb-0 text-muted">Loading employee details...</p>
              </div>
            )}
            <div
              className="row"
              style={{ display: isRefreshing ? "none" : undefined }}
            >
              <div className="col-xl-4 theiaStickySidebar">
                <div className="card card-bg-1">
                  <div className="card-body p-0">
                    <span
                      className="avatar avatar-xl avatar-rounded border border-2 border-white m-auto d-flex mb-2"
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                        overflow: "hidden", // Crops extra image parts
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() => setShowFullImage(true)}
                    >
                      <ImageWithBasePath
                        src={data.Image || "assets/img/users/user.png"}
                        className="w-100 h-100" // Force image to fill container
                        alt="Img"
                      />
                    </span>

                    <Modal
                      open={showFullImage}
                      footer={null}
                      onCancel={() => setShowFullImage(false)}
                      centered
                      width={500}
                    >
                      <img
                        src={data.Image || "assets/img/users/user.png"}
                        alt="Full Employee"
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: "8px",
                        }}
                      />
                    </Modal>

                    <div className="text-center px-3 pb-3 border-bottom">
                      <div className="mb-3">
                        <h5 className="d-flex align-items-center justify-content-center mb-1">
                          {data.Name}
                          <i className="ti ti-discount-check-filled text-success ms-1" />
                        </h5>
                        <span className="badge badge-soft-dark fw-medium me-2">
                          <i className="ti ti-point-filled me-1" />
                          {data.Role}
                        </span>
                      </div>
                      <div>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <h6>Employee Information</h6>
                          {(hasEditPermissionForEmployees === true ||
                            user?.userDetails.role_char?.toLowerCase() ===
                            "admin") && (
                              <Link
                                to="#"
                                className="btn btn-icon btn-sm"
                                data-bs-toggle="modal"
                                data-inert={true}
                                data-bs-target="#employee_info"
                              >
                                <i className="ti ti-edit" />
                              </Link>
                            )}
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <span className="d-inline-flex align-items-center">
                            <i className="ti ti-id me-2" />
                            Employee ID
                          </span>
                          <p className="text-dark">{data.Employee_ID}</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <span className="d-inline-flex align-items-center">
                            <i className="ti ti-briefcase me-2" />
                            Department
                          </span>
                          <p className="text-dark">{data.Department}</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <span className="d-inline-flex align-items-center">
                            <i className="ti ti-calendar-check me-2" />
                            Date Of Joining
                          </span>
                          <p className="text-dark text-end">
                            {moment(data?.JoiningDate).format("DD-MM-YYYY")}
                          </p>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <span className="d-inline-flex align-items-center">
                            <i className="ti ti-hierarchy me-2" />
                            Reporting Officer
                          </span>
                          <div className="d-flex align-items-center">
                            <span className="avatar avatar-sm avatar-rounded me-2">
                              <ImageWithBasePath
                                src={data.ReportingOfficerPic}
                                className="img-fluid h-auto w-auto"
                                alt="employee"
                              />
                            </span>
                            <Link
                              key={data.ReportingOfficerId}
                              to={all_routes.employeedetails.replace(
                                ":id",
                                data.ReportingOfficerId
                              )}
                              state={{
                                type: "report_officer",
                                user_id: data.key,
                              }}
                            >
                              <p className="text-gray-9 mb-0">
                                {data.ReportingOfficerName.toLowerCase().trim() ==
                                  "undefined"
                                  ? "N/A"
                                  : data.ReportingOfficerName}
                              </p>
                            </Link>
                          </div>
                        </div>
                        <div className="row gx-2 mt-3">
                          <div className="col-12">
                            <div>
                              <Link
                                to="#"
                                className="btn btn-primary w-100"
                                onClick={() => {
                                  showBasicAlert("Coming SoonI");
                                }}
                              >
                                <i className="ti ti-message-heart me-1" />
                                Message
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-3 border-bottom">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <h6>Basic information</h6>
                        {(hasEditPermissionForEmployees === true ||
                          user?.userDetails.role_char?.toLowerCase() ===
                          "admin") && (
                            <Link
                              to="#"
                              className="btn btn-icon btn-sm"
                              data-bs-toggle="modal"
                              data-inert={true}
                              data-bs-target="#edit_personal_info"
                            >
                              <i className="ti ti-edit" />
                            </Link>
                          )}
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-phone me-2" />
                          Phone
                        </span>
                        <p className="text-dark">{data.Phone}</p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-phone me-2" />
                          Official-Phone
                        </span>
                        <p className="text-dark">
                          {data.Official_Phone == "null-null"
                            ? "N/A"
                            : data.Official_Phone}
                        </p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-mail-check me-2" />
                          Email
                        </span>
                        <Link
                          to="#"
                          className="text-info d-inline-flex align-items-center"
                          onClick={(e) => e.preventDefault()} // Prevent navigation on clicking the link
                        >
                          {data.Email}{" "}
                          <i
                            className="ti ti-copy text-dark ms-2"
                            onClick={handleCopyEmail} // Attach the copy functionality here
                            style={{ cursor: "pointer" }} // Make it look clickable
                          />
                        </Link>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-gender-male me-2" />
                          Gender
                        </span>
                        <p className="text-dark text-end">
                          {data.Gender === "M"
                            ? "Male"
                            : data.Gender === "F"
                              ? "Female"
                              : "Others"}
                        </p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-cake me-2" />
                          Birthday
                        </span>
                        <p className="text-dark text-end">
                          {" "}
                          {moment(data?.DOB).format("DD-MM-YYYY")}
                        </p>
                      </div>
                    </div>
                    <div className="p-3 border-bottom">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <h6>Address Details</h6>
                        {(hasEditPermissionForEmployees === true ||
                          user?.userDetails.role_char?.toLowerCase() ===
                          "admin") && (
                            <Link
                              to="#"
                              className="btn btn-icon btn-sm"
                              data-bs-toggle="modal"
                              data-inert={true}
                              data-bs-target="#edit_address"
                            >
                              <i className="ti ti-edit" />
                            </Link>
                          )}
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-4">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-map-pin-check me-2" />
                          Current Address
                        </span>
                        <p className="text-dark text-end">
                          {employeeAddress?.c_address1 || "N/A"},
                          {employeeAddress?.c_address2 || "N/A"},
                          {citiesOrignal.find(
                            (item) =>
                              parseInt(item.id) ==
                              parseInt(employeeAddress?.c_city)
                          )?.name || "N/A"}
                          ,
                          {statesOrignal.find(
                            (item) =>
                              parseInt(item.id) ==
                              parseInt(employeeAddress?.c_state)
                          )?.name || "N/A"}
                          ,
                          {countries.find(
                            (item) =>
                              parseInt(item.id) ==
                              parseInt(employeeAddress?.c_country)
                          )?.name || "N/A"}
                          ,{employeeAddress.c_pincode}
                        </p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-map-pin-check me-2" />
                          Address
                        </span>
                        <p className="text-dark text-end">
                          {employeeAddress?.address1 || "N/A"},
                          {employeeAddress?.address2 || "N/A"},
                          {citiesOrignal.find(
                            (item) =>
                              parseInt(item.id) ==
                              parseInt(employeeAddress?.city)
                          )?.name || "N/A"}
                          ,
                          {statesOrignal.find(
                            (item) =>
                              parseInt(item.id) ==
                              parseInt(employeeAddress?.state)
                          )?.name || "N/A"}
                          ,
                          {countries.find(
                            (item) =>
                              parseInt(item.id) ==
                              parseInt(employeeAddress?.country)
                          )?.name || "N/A"}
                          ,{employeeAddress.pincode}
                        </p>
                      </div>
                    </div>
                    <div className="p-3 border-bottom">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <h6>Personal Information</h6>
                        {(hasEditPermissionForEmployees === true ||
                          user?.userDetails.role_char?.toLowerCase() ===
                          "admin") && (
                            <Link
                              to="#"
                              className="btn btn-icon btn-sm"
                              data-bs-toggle="modal"
                              data-inert={true}
                              data-bs-target="#edit_personal"
                            >
                              <i className="ti ti-edit" />
                            </Link>
                          )}
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-world me-2" />
                          Nationality
                        </span>
                        <p className="text-dark text-end">
                          {employeePersonal.nationality || "N/A"}
                        </p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-book me-2" />
                          Religion
                        </span>
                        <p className="text-dark text-end">
                          {employeePersonal.religion || "N/A"}
                        </p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-user-heart me-2" />
                          Marital status
                        </span>
                        <p className="text-dark text-end">
                          {employeePersonal.marital_status?.toLowerCase() ===
                            "no"
                            ? "Un-Married"
                            : employeePersonal.marital_status?.toLowerCase() ===
                              "yes"
                              ? "Married"
                              : "N/A"}
                        </p>
                      </div>
                      {employeePersonal.marital_status?.toLowerCase() ===
                        "yes" && (
                          <div>
                            <div className="d-flex align-items-center justify-content-between mb-2">
                              <span className="d-inline-flex align-items-center">
                                <i className="ti ti-users me-2" />
                                Spouse Name
                              </span>
                              <p className="text-dark text-end">
                                {employeePersonal.spouse_name || "N/A"}
                              </p>
                            </div>

                            <div className="d-flex align-items-center justify-content-between mb-2">
                              <span className="d-inline-flex align-items-center">
                                <i className="ti ti-calendar-heart me-2" />
                                Anniversary Date
                              </span>
                              <p className="text-dark text-end">
                                {employeePersonal.anniversary_date || "N/A"}
                              </p>
                            </div>

                            <div className="d-flex align-items-center justify-content-between mb-2">
                              <span className="d-inline-flex align-items-center">
                                <i className="ti ti-device-mobile me-2" />
                                Spouse Contact No
                              </span>
                              <p className="text-dark text-end">
                                {employeePersonal.spouse_contact || "N/A"}
                              </p>
                            </div>
                          </div>
                        )}
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-droplet me-2" />
                          Blood Group
                        </span>
                        <p className="text-dark text-end">
                          {employeePersonal.blood_group || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <h6>Emergency Contact Number</h6>
                  {(hasEditPermissionForEmployees === true ||
                    user?.userDetails.role_char?.toLowerCase() === "admin") && (
                      <Link
                        to="#"
                        className="btn btn-icon btn-sm"
                        data-bs-toggle="modal"
                        data-inert={true}
                        data-bs-target="#edit_emergency"
                      >
                        <i className="ti ti-edit" />
                      </Link>
                    )}
                </div>
                <div className="card">
                  <div className="card-body p-0">
                    <div className="p-3 border-bottom">
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <span className="d-inline-flex align-items-center">
                            Primary
                          </span>
                          <h6 className="d-flex align-items-center fw-medium mt-1">
                            {employeePersonal.emergency_name1 || "N/A"}{" "}
                            <span className="d-inline-flex mx-1">
                              <i className="ti ti-point-filled text-danger" />
                            </span>
                            {employeePersonal.emergency_relation1 || "N/A"}
                          </h6>
                        </div>
                        <p className="text-dark">
                          {employeePersonal.emergency_no1 || "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="p-3 border-bottom">
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <span className="d-inline-flex align-items-center">
                            Secondry
                          </span>
                          <h6 className="d-flex align-items-center fw-medium mt-1">
                            {employeePersonal.emergency_name2 || "N/A"}{" "}
                            <span className="d-inline-flex mx-1">
                              <i className="ti ti-point-filled text-danger" />
                            </span>
                            {employeePersonal.emergency_relation2 || "N/A"}
                          </h6>
                        </div>
                        <p className="text-dark">
                          {employeePersonal.emergency_no2 || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-8">
                <div>
                  <div className="tab-content custom-accordion-items">
                    <div
                      className="tab-pane active show"
                      id="bottom-justified-tab1"
                      role="tabpanel"
                    >
                      <div
                        className="accordion accordions-items-seperate"
                        id="accordionExample"
                      >
                        {user?.userDetails.role_char.toLowerCase() !=
                          "admins" && (
                            <div className="accordion-item">
                              <div className="accordion-header" id="headingOne">
                                <div
                                  className="accordion-button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#primaryBorderOne"
                                  aria-expanded="true"
                                  aria-controls="primaryBorderOne"
                                >
                                  <div className="d-flex align-items-center justify-content-between flex-fill">
                                    <h5>Key Responsibilities</h5>
                                    <div className="d-flex">
                                      {/* <Link
                                      to="#"
                                      className="btn btn-sm btn-icon ms-auto"
                                      data-bs-toggle="modal"
                                      data-inert={true}
                                      data-bs-target="#edit_bank"
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <i className="ti ti-edit" />
                                    </Link> */}
                                      <Link
                                        to="#"
                                        className="d-flex align-items-center collapsed collapse-arrow"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#primaryBorderOne"
                                        aria-expanded="true"
                                        aria-controls="primaryBorderOne"
                                      >
                                        <i className="ti ti-chevron-down fs-18" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                id="primaryBorderOne"
                                className="accordion-collapse collapse border-top"
                                aria-labelledby="headingOne"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <div className="d-flex flex-wrap gap-2">
                                    {data.responsibilities?.map(
                                      (item: any, idx: any) => (
                                        <span
                                          key={idx}
                                          className="badge bg-primary px-3 py-2 rounded-pill shadow-sm"
                                        >
                                          <i className="ti ti-check me-1" />{" "}
                                          {item}
                                        </span>
                                      )
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                        <div className="accordion-item">
                          <div className="accordion-header" id="headingTwo">
                            <div
                              className="accordion-button"
                              data-bs-toggle="collapse"
                              data-bs-target="#primaryBorderTwo"
                              aria-expanded="false"
                              aria-controls="primaryBorderTwo"
                            >
                              <div className="d-flex align-items-center justify-content-between flex-fill">
                                <h5>Bank Information</h5>
                                <div className="d-flex">
                                  {(hasEditPermissionForEmployees === true ||
                                    user?.userDetails.role_char?.toLowerCase() ===
                                    "admin") && (
                                      <Link
                                        to="#"
                                        className="btn btn-sm btn-icon ms-auto"
                                        data-bs-toggle="modal"
                                        data-inert={true}
                                        data-bs-target="#edit_bank"
                                        onClick={(e) => e.stopPropagation()}
                                      >
                                        <i className="ti ti-edit" />
                                      </Link>
                                    )}
                                  <Link
                                    to="#"
                                    className="d-flex align-items-center collapsed collapse-arrow"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#primaryBorderTwo"
                                    aria-expanded="false"
                                    aria-controls="primaryBorderTwo"
                                  >
                                    <i className="ti ti-chevron-down fs-18" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="primaryBorderTwo"
                            className="accordion-collapse collapse border-top"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <div className="row">
                                <div className="col-md-3">
                                  <span className="d-inline-flex align-items-center">
                                    Bank Name
                                  </span>
                                  <h6 className="d-flex align-items-center fw-medium mt-1">
                                    {employeeBankDetails?.bank_name || "N/A"}
                                  </h6>
                                </div>
                                <div className="col-md-3">
                                  <span className="d-inline-flex align-items-center">
                                    Bank account no
                                  </span>
                                  <h6 className="d-flex align-items-center fw-medium mt-1">
                                    {employeeBankDetails?.account_no || "N/A"}
                                  </h6>
                                </div>
                                <div className="col-md-3">
                                  <span className="d-inline-flex align-items-center">
                                    IFSC Code
                                  </span>
                                  <h6 className="d-flex align-items-center fw-medium mt-1">
                                    {employeeBankDetails?.ifsc_code || "N/A"}
                                  </h6>
                                </div>
                                <div className="col-md-3">
                                  <span className="d-inline-flex align-items-center">
                                    Branch
                                  </span>
                                  <h6 className="d-flex align-items-center fw-medium mt-1">
                                    {employeeBankDetails?.branch_address ||
                                      "N/A"}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-item">
                          <div className="accordion-header" id="headingThree">
                            <div
                              className="accordion-button"
                              data-bs-toggle="collapse"
                              data-bs-target="#primaryBorderThree"
                              aria-expanded="false"
                              aria-controls="primaryBorderThree"
                            >
                              <div className="d-flex align-items-center justify-content-between flex-fill">
                                <h5>Family Information</h5>
                                <div className="d-flex">
                                  {(hasEditPermissionForEmployees === true ||
                                    user?.userDetails.role_char?.toLowerCase() ===
                                    "admin") && (
                                      <Link
                                        to="#"
                                        className="btn btn-icon btn-sm"
                                        data-bs-toggle="modal"
                                        data-inert={true}
                                        data-bs-target="#edit_familyinformation"
                                        onClick={(e) => e.stopPropagation()}
                                      >
                                        <i className="ti ti-edit" />
                                      </Link>
                                    )}
                                  <Link
                                    to="#"
                                    className="d-flex align-items-center collapsed collapse-arrow"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#primaryBorderThree"
                                    aria-expanded="false"
                                    aria-controls="primaryBorderThree"
                                  >
                                    <i className="ti ti-chevron-down fs-18" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="primaryBorderThree"
                            className="accordion-collapse collapse border-top"
                            aria-labelledby="headingThree"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <div className="row">
                                <div className="col-md-3">
                                  <span className="d-inline-flex align-items-center">
                                    Name
                                  </span>
                                  <h6 className="d-flex align-items-center fw-medium mt-1">
                                    {employeePersonal.family_name || "N/A"}
                                  </h6>
                                </div>
                                <div className="col-md-3">
                                  <span className="d-inline-flex align-items-center">
                                    Relationship
                                  </span>
                                  <h6 className="d-flex align-items-center fw-medium mt-1">
                                    {employeePersonal.family_relation || "N/A"}
                                  </h6>
                                </div>
                                <div className="col-md-3">
                                  <span className="d-inline-flex align-items-center">
                                    Phone
                                  </span>
                                  <h6 className="d-flex align-items-center fw-medium mt-1">
                                    {employeePersonal.contact_no || "N/A"}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-item">
                          <div className="accordion-header" id="headingFour">
                            <div
                              className="accordion-button"
                              data-bs-toggle="collapse"
                              data-bs-target="#primaryBorderFour"
                              aria-expanded="false"
                              aria-controls="primaryBorderFour"
                            >
                              <div className="d-flex align-items-center justify-content-between flex-fill">
                                <h5>Asset Information</h5>
                                <div className="d-flex">
                                  <Link
                                    to="#"
                                    className="d-flex align-items-center collapsed collapse-arrow"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#primaryBorderFour"
                                    aria-expanded="false"
                                    aria-controls="primaryBorderFour"
                                  >
                                    <i className="ti ti-chevron-down fs-18" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="primaryBorderFour"
                            className="accordion-collapse collapse border-top"
                            aria-labelledby="headingFour"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-3">
                              {" "}
                              {/* g-3 = grid spacing reduce */}
                              {assignedAsset?.map((item, idx) => (
                                <div
                                  className="col-lg-12 col-md-12"
                                  key={item?.id}
                                >
                                  <div className="h-80 shadow-sm border-0">
                                    <div className="card-body py-3 px-4">
                                      {" "}
                                      {/* Reduced padding */}
                                      <div className="row align-items-center">
                                        {/* Product Info */}
                                        <div className="col-6 d-flex align-items-center">
                                          <li className="avatar avatar-xl avatar-rounded object-cover flex-shrink-0">
                                            <ImageWithBasePath
                                              src={
                                                !item?.image ||
                                                  item?.image === "null"
                                                  ? "assets/img/products/product-icon.png"
                                                  : item?.image
                                              }
                                              alt="img"
                                            />
                                          </li>
                                          <div>
                                            <h6 className="mb-1">
                                              <Link
                                                to="#"
                                                className="text-dark text-decoration-none"
                                              >
                                                {item?.product_id}
                                              </Link>
                                            </h6>
                                            <small className="text-muted d-block">
                                              {item?.serial_no || "N/A"}
                                            </small>
                                            <small className="text-muted d-block">
                                              Assigned Date:{" "}
                                              {humanReadableDate(item?.assigned_date)}
                                            </small>

                                            {
                                              item.returned_date && (
                                                <small className="badge badge-danger-transparent badge-sm d-block">
                                                  Returned Date:{" "}
                                                  {humanReadableDate(item.returned_date)}
                                                </small>
                                              )
                                            }

                                            {item?.status === "Lost" && (
                                              <small
                                                className="badge badge-warning badge-sm d-inline-flex align-items-center mt-1"
                                                title={item?.lost_remark || ""}
                                              >
                                                <i className="ti ti-alert-triangle me-1" />
                                                Lost
                                              </small>
                                            )}

                                          </div>
                                        </div>

                                        {/* Assigned By */}
                                        <div className="col-5">

                                          <small className="text-muted d-block fs-13">
                                            Assigned By:
                                          </small>

                                          <div className="d-flex align-items-center ">

                                            <li className="avatar avatar-lg avatar-rounded object-cover flex-shrink-0">
                                              <ImageWithBasePath
                                                src={
                                                  !item?.assigned_by_url ||
                                                    item?.assigned_by_url === "null"
                                                    ? "assets/img/users/user.png"
                                                    : item?.assigned_by_url
                                                }
                                                alt="img"
                                              />
                                            </li>


                                            <span className="text-truncate">
                                              {item?.assigned_by_raw || "Name N/F"}
                                            </span>

                                          </div>

                                        </div>

                                        {/* Actions */}
                                        <div className="col-1 text-end d-flex gap-2 justify-content-end">
                                          {/* View Details Icon Button */}
                                          <button
                                            type="button"
                                            className="btn btn-light d-flex align-items-center justify-content-center"
                                            data-bs-toggle="modal" // Required for modal
                                            data-bs-target="#asset_info" // Target modal
                                            onClick={() =>
                                              getAssetInformations(item?.id)
                                            }
                                            title="View Details" // Tooltip
                                            data-bs-placement="top"
                                          >
                                            <i className="ti ti-eye"></i>
                                          </button>

                                          {/* Raise Issue Icon Button */}
                                          <button
                                            type="button"
                                            className="btn btn-outline-danger d-flex align-items-center justify-content-center"
                                            data-bs-toggle="modal" // Required for modal
                                            data-bs-target="#refuse_msg" // Target modal
                                            onClick={() =>
                                              handleRaiseIssueClick(item?.id)
                                            }
                                            title="Raise Issue" // Tooltip
                                            data-bs-placement="top"
                                          >
                                            <i className="ti ti-alert-triangle"></i>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
            <p className="mb-0">2025 © CMS.</p>
            <p>
              Designed & Developed By{" "}
              <Link to="#" className="text-primary">
                ZYVO
              </Link>
            </p>
          </div>
        </div >
        {/* /Page Wrapper */}

        {/* Edit Employee  Info */}
        <div className="modal fade" id="employee_info">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Employee Info</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body pb-0">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Employee ID <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={FormDataEmployeeDetails.employee_id}
                          name="employee_id"
                          onChange={handleInputChangEmployeeDetails}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-white border me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                    onClick={handleSubmitEmployeeInfo}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Edit Employee Info */}

        {/* Edit Basic Info */}
        <div className="modal fade" id="edit_personal_info">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Basic Info</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body pb-0">
                  <div className="row">
                    <div className="row col-md-12">
                      <div className="col-md-2 mb-3">
                        <label className="form-label">
                          Code <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="phone_code"
                          value={FormDataEmployeeBasicDetails.phone_code}
                          onChange={handleInputChangEmployeeBasicDetails}
                        >
                          <option value="">Select</option>
                          {countries.map((country, index) => (
                            <option key={index} value={country.phonecode}>
                              {country.ios2} {emojiFromUPlus(country.emojiU)}
                              {" +"}
                              {country.phonecode}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-10 mb-3">
                        <label className="form-label">
                          Phone <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="mobile_no"
                          className="form-control"
                          value={FormDataEmployeeBasicDetails.mobile_no}
                          onChange={handleInputChangEmployeeBasicDetails}
                          maxLength={10}
                        />
                      </div>
                    </div>

                    <div className="row col-md-12">
                      <div className="col-md-2 mb-3">
                        <label className="form-label">
                          Code <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="official_phone_code"
                          value={
                            FormDataEmployeeBasicDetails.official_phone_code
                          }
                          onChange={handleInputChangEmployeeBasicDetails}
                        >
                          <option value="">Select</option>
                          {countries.map((country, index) => (
                            <option key={index} value={country.phonecode}>
                              {country.ios2} {emojiFromUPlus(country.emojiU)}
                              {" +"}
                              {country.phonecode}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-10 mb-3">
                        <label className="form-label">
                          Official Phone <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="official_mobile_no"
                          className="form-control"
                          value={
                            FormDataEmployeeBasicDetails.official_mobile_no
                          }
                          onChange={handleInputChangEmployeeBasicDetails}
                          maxLength={10}
                        />
                      </div>
                    </div>

                    <div className="row col-md-12">
                      <div className="col-md-12 mb-3">
                        <label className="form-label">
                          Email <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          value={FormDataEmployeeBasicDetails.email}
                          onChange={handleInputChangEmployeeBasicDetails}
                        />
                      </div>
                    </div>

                    <div className="row col-md-12">
                      <div className="col-md-12 mb-3">
                        <label className="form-label">
                          Gender <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          value={FormDataEmployeeBasicDetails.gender}
                          name="gender"
                          onChange={handleInputChangEmployeeBasicDetails}
                        >
                          <option value="M">Male</option>
                          <option value="F">Female</option>
                          <option value="O">Others</option>
                        </select>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label>Date of Birth</label>
                      <input
                        type="date"
                        name="dob"
                        className="form-control"
                        value={FormDataEmployeeBasicDetails.dob}
                        onChange={handleInputChangEmployeeBasicDetails}
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-white border me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                    onClick={handleSubmitEmployeeBasicDetails}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Edit Basic Info */}

        {/* Edit Address */}
        <div className="modal fade" id="edit_address">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Address</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body pb-0">
                  {/* Permanent Address Section */}
                  <h5 className="mb-3">Permanent Address</h5>
                  <div className="row">
                    {/* Address 1 */}
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Address 1</label>
                        <input
                          type="text"
                          className="form-control"
                          name="address1"
                          value={formDataAddress.address1}
                          onChange={handleInputChangeAddress}
                        />
                      </div>
                    </div>
                    {/* Address 2 */}
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Address 2</label>
                        <input
                          type="text"
                          className="form-control"
                          name="address2"
                          value={formDataAddress.address2}
                          onChange={handleInputChangeAddress}
                        />
                      </div>
                    </div>
                    {/* Country */}
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label className="form-label">
                          Country <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="country"
                          value={formDataAddress.country}
                          onChange={handleCountryChange}
                        >
                          <option value="">Select Country</option>
                          {countries.map((country) => (
                            <option key={country.id} value={country.id}>
                              {country.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* State */}
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label className="form-label">
                          State <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="state"
                          value={formDataAddress.state}
                          onChange={handleStateChange}
                          disabled={!formDataAddress.country}
                        >
                          <option value="">Select State</option>
                          {states.map((state) => (
                            <option key={state.id} value={state.id}>
                              {state.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* City */}
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label className="form-label">
                          City <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="city"
                          value={formDataAddress.city}
                          onChange={handleCityChange}
                          disabled={!formDataAddress.state}
                        >
                          <option value="">Select City</option>
                          {cities.map((city) => (
                            <option key={city.id} value={city.id}>
                              {city.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Pincode */}
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label className="form-label">Pincode</label>
                        <input
                          type="text"
                          className="form-control"
                          name="pincode"
                          value={formDataAddress.pincode}
                          onChange={handleInputChangeAddress}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Checkbox for Auto-fill */}
                  <div className="form-check my-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="sameAddress"
                      checked={sameAsPermanent}
                      onChange={(e) =>
                        handleSameAddressToggle(e.target.checked)
                      }
                    />
                    <label className="form-check-label" htmlFor="sameAddress">
                      Current Address same as Permanent Address
                    </label>
                  </div>

                  {/* Current Address Section */}
                  <h5 className="mb-3">Current Address</h5>
                  <div className="row">
                    {/* Address 1 */}
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Address 1</label>
                        <input
                          type="text"
                          className="form-control"
                          name="c_address1"
                          value={formDataAddress.c_address1}
                          onChange={handleInputChangeAddress}
                          disabled={sameAsPermanent}
                        />
                      </div>
                    </div>
                    {/* Address 2 */}
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Address 2</label>
                        <input
                          type="text"
                          className="form-control"
                          name="c_address2"
                          value={formDataAddress.c_address2}
                          onChange={handleInputChangeAddress}
                          disabled={sameAsPermanent}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label className="form-label">
                          Country <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="c_country"
                          value={formDataAddress.c_country}
                          onChange={handleCurrentCountryChange}
                        >
                          <option value="">Select Country</option>
                          {c_countries.map((country) => (
                            <option key={country.id} value={country.id}>
                              {country.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* State */}
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label className="form-label">
                          State <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="c_state"
                          value={formDataAddress.c_state}
                          onChange={handleCurrentStateChange}
                          disabled={!formDataAddress.c_country}
                        >
                          <option value="">Select State</option>
                          {c_states.map((state) => (
                            <option key={state.id} value={state.id}>
                              {state.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* City */}
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label className="form-label">
                          City <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="c_city"
                          value={formDataAddress.c_city}
                          onChange={handleCurrentCityChange}
                          disabled={!formDataAddress.c_state}
                        >
                          <option value="">Select City</option>
                          {c_cities.map((city) => (
                            <option key={city.id} value={city.id}>
                              {city.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Pincode */}
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label className="form-label">Pincode</label>
                        <input
                          type="text"
                          className="form-control"
                          name="c_pincode"
                          value={formDataAddress.c_pincode}
                          onChange={handleInputChangeAddress}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-white border me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                    onClick={handleSubmitAddress}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* /Edit Address */}
        {/* Edit Personal */}
        <div className="modal fade" id="edit_personal">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Personal Info</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body pb-0">
                  <div className="row">
                    {/* Nationality */}
                    <div className="col-md-4">
                      <div className="col-md-12">
                        <div className="mb-6">
                          <label className="form-label">
                            Nationality <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="form-control"
                            name="country"
                            value={formDataPersonal.nationality}
                            onChange={handleCountryChangePersonal}
                          >
                            <option value="">Select Country</option>
                            {countries.map((country) => (
                              <option key={country.id} value={country.name}>
                                {country.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    {/* Religion */}
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Religion</label>
                        <input
                          type="text"
                          className="form-control"
                          name="religion"
                          value={formDataPersonal.religion}
                          onChange={handleInputChangePersonal}
                        />
                      </div>
                    </div>

                    {/* Blood Group */}
                    <div className="col-md-4">
                      <div className="mb-6">
                        <label className="form-label">
                          Blood Group <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="blood_group"
                          value={formDataPersonal.blood_group}
                          onChange={handleBloodGroupChangePersonal}
                        >
                          <option value="">Select Blood Group</option>
                          {bloodGroups.map((group) => (
                            <option key={group.value} value={group.value}>
                              {group.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Marital Status */}
                    <div className="col-md-12">
                      <div className="mb-6">
                        <label className="form-label">
                          Marital Status <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="marital"
                          value={formDataPersonal.marital}
                          onChange={(e) => {
                            handleMaritialChangePersonal(e);
                            setFormDataPersonal((prev) => ({
                              ...prev,
                              marital: e.target.value,
                            }));
                          }}
                        >
                          <option value="">Select Status</option>
                          {martialstatus.map((status) => (
                            <option key={status.value} value={status.value}>
                              {status.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Conditional Married Info */}
                    {formDataPersonal.marital === "Yes" && (
                      <>
                        <div className="col-md-6">
                          <div className="mb-3 mt-3">
                            <label className="form-label">
                              Spouse Name{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="spouse_name"
                              value={formDataPersonal.spouse_name || ""}
                              onChange={handleInputChangePersonal}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3  mt-3">
                            <label className="form-label">
                              Anniversary Date{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              name="anniversary_date"
                              value={formDataPersonal.anniversary_date || ""}
                              onChange={handleInputChangePersonal}
                            />
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Spouse Contact{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="spouse_contact"
                              value={formDataPersonal.spouse_contact || ""}
                              onChange={handleInputChangePersonal}
                              maxLength={10}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-white border me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                    onClick={handleSubmitPersonal}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* /Edit Personal */}
        {/* Edit Emergency Contact */}
        <div className="modal fade" id="edit_emergency">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Emergency Contact Details</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body pb-0">
                  <div className="border-bottom mb-3 ">
                    <div className="row">
                      <h5 className="mb-3">Primary Contact Details</h5>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formDataEmergencyDetail.emergency_name1}
                            name="emergency_name1"
                            onChange={handleInputChangeEmergencyDetails1}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Relationship <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="form-control"
                            name="emergency_relation1"
                            value={formDataEmergencyDetail.emergency_relation1}
                            onChange={handleRelationShip1Change}
                          >
                            <option value="">Select Relationship</option>
                            {relationship.map((relation) => (
                              <option
                                key={relation.label}
                                value={relation.value}
                              >
                                {relation.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Phone No 1 <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="emergency_no1"
                            value={formDataEmergencyDetail.emergency_no1}
                            onChange={handleInputChangeEmergencyDetails1}
                            required
                            maxLength={10}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="border-bottom mb-3 ">
                    <div className="row">
                      <h5 className="mb-3">Secondary Contact Details</h5>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="emergency_name2"
                            value={formDataEmergencyDetail.emergency_name2}
                            onChange={handleInputChangeEmergencyDetails2}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Relationship <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="form-control"
                            name="emergency_relation2"
                            value={formDataEmergencyDetail.emergency_relation2}
                            onChange={handleRelationShip2Change}
                          >
                            <option value="">Select Relationship</option>
                            {relationship.map((relation) => (
                              <option
                                key={relation.label}
                                value={relation.value}
                              >
                                {relation.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Phone No 1 <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="emergency_no2"
                            value={formDataEmergencyDetail.emergency_no2}
                            onChange={handleInputChangeEmergencyDetails2}
                            required
                            maxLength={10}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-white border me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                    onClick={handleSubmitEmergency}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Edit Emergency Contact */}
        {/* Edit Bank */}
        <div className="modal fade" id="edit_bank">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Bank Details</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body pb-0">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">
                          Bank Name <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="bank_name"
                          value={formDataBankDetails.bank_name}
                          onChange={handleInputChangeBankDetails}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Bank account No </label>
                        <input
                          type="text"
                          className="form-control"
                          name="account_no"
                          value={formDataBankDetails.account_no}
                          onChange={handleInputChangeBankDetails}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">IFSC Code</label>
                        <input
                          type="text"
                          className="form-control"
                          name="ifsc_code"
                          value={formDataBankDetails.ifsc_code}
                          onChange={handleInputChangeBankDetails}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Branch Address</label>
                        <input
                          type="text"
                          className="form-control"
                          name="branch_address"
                          value={formDataBankDetails.branch_address}
                          onChange={handleInputChangeBankDetails}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-white border me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                    onClick={handleSubmitBankDetails}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Edit Bank */}
        {/* Add Family */}
        <div className="modal fade" id="edit_familyinformation">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Family Information</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body pb-0">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">
                          Name <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={formDataFamilyInfo.name}
                          onChange={handleInputChangeFamilyInfo}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">
                          Relationship <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="relationship"
                          value={formDataFamilyInfo.relationship}
                          onChange={handleRelationShipFamily}
                        >
                          <option value="">Select Relationship</option>
                          {relationship.map((relation) => (
                            <option key={relation.label} value={relation.value}>
                              {relation.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Phone </label>
                        <input
                          type="text"
                          className="form-control"
                          name="phone_no"
                          value={formDataFamilyInfo.phone_no}
                          onChange={handleInputChangeFamilyInfo}
                          maxLength={10}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-white border me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                    onClick={handleSubmitFamilyInfo}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Add Family */}

        {/* Add Employee Success */}
        <div className="modal fade" id="success_modal" role="dialog">
          <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content">
              <div className="modal-body">
                <div className="text-center p-3">
                  <span className="avatar avatar-lg avatar-rounded bg-success mb-3">
                    <i className="ti ti-check fs-24" />
                  </span>
                  <h5 className="mb-2">Employee Added Successfully</h5>
                  <p className="mb-3">
                    Stephan Peralt has been added with Client ID :{" "}
                    <span className="text-primary">#EMP - 0001</span>
                  </p>
                  <div>
                    <div className="row g-2">
                      <div className="col-6">
                        <Link
                          to={
                            comingFromtype == "emp_list"
                              ? all_routes.employeeList
                              : all_routes.employeeGrid
                          }
                        >
                          Back to List
                        </Link>
                      </div>
                      <div className="col-6">
                        <Link
                          to={all_routes.employeedetails}
                          className="btn btn-primary w-100"
                        >
                          Detail Page
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Add Client Success */}
        {/* Add Statuorty */}

        {/* /Add Statuorty */}
        {/* Asset Information */}
        <EmployeeAssetsInformation
          assignedAssetInformation={assignedAssetInformation}
        />
        {/* /Asset Information */}
        {/* Refuse */}
        <div className="modal fade" id="refuse_msg">
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Raise Issue</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body pb-0">
                  <div className="row">
                    {/* Category Dropdown */}
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">
                          Select Category<span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="key"
                          value={requestBody.key}
                          onChange={handleChange}
                        >
                          <option value="">Select Category</option>
                          {ticketCategories.map((category) => (
                            <option key={category.key} value={category.key}>
                              {category.Category}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Priority Radio Buttons */}
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">
                          Priority<span className="text-danger"> *</span>
                        </label>
                        <div className="d-flex gap-3">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="Priority"
                              value="0"
                              checked={requestBody.Priority === "0"}
                              onChange={handleChange}
                            />
                            <label className="form-check-label">Low</label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="Priority"
                              value="1"
                              checked={requestBody.Priority === "1"}
                              onChange={handleChange}
                            />
                            <label className="form-check-label">Medium</label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="Priority"
                              value="2"
                              checked={requestBody.Priority === "2"}
                              onChange={handleChange}
                            />
                            <label className="form-check-label">High</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Title Input */}
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">
                          Title<span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="Title"
                          value={requestBody.Title}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    {/* Description Input */}
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">
                          Description<span className="text-danger"> *</span>
                        </label>
                        <textarea
                          className="form-control"
                          rows={4}
                          name="Description"
                          value={requestBody.Description}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-white border me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={submitRaiseIssue}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Refuse */}
        <ToastContainer />
      </>
    );
  }
};

export default EmployeeDetails;
